const L = {
  name: "Pin",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2929 2.29289C15.6834 1.90237 16.3166 1.90237 16.7071 2.29289L21.7071 7.29289C22.0976 7.68342 22.0976 8.31658 21.7071 8.70711C21.3166 9.09763 20.6834 9.09763 20.2929 8.70711L20.067 8.48119L16.1416 13.1885C16.7576 15.6186 16.1132 18.301 14.2071 20.2071L13 21.4142L8.50004 16.9142L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L7.08583 15.5L2.58582 10.9999L3.79292 9.79284C5.69902 7.88675 8.38146 7.24234 10.8117 7.85841L15.5189 3.93309L15.2929 3.70711C14.9024 3.31658 14.9024 2.68342 15.2929 2.29289ZM18.647 7.06119L16.9389 5.35309L11.2519 10.0954L10.721 9.91558C8.93604 9.31081 6.90094 9.67453 5.41976 11.0055L12.9945 18.5802C14.3254 17.0991 14.6892 15.064 14.0844 13.2791L13.9046 12.7482L18.647 7.06119Z" fill="currentColor"/>
    </g>
  `
};
export {
  L as Pin
};
